import React, { Children } from 'react';
import { PlusIcon } from 'lucide-react';
import { useCart } from '../context/CartContext';
const PRODUCTS = [{
  id: 1,
  storeId: 'annapolis',
  name: 'Advanced Multivitamin Complex',
  category: 'Vitamins & Supplements',
  price: '$24.99',
  image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?q=80&w=800&auto=format&fit=crop'
}, {
  id: 2,
  storeId: 'annapolis',
  name: 'Nighttime Cough & Cold Relief',
  category: 'Cough, Cold & Flu',
  price: '$12.50',
  image: 'https://images.unsplash.com/photo-1550572017-ed20015dd085?q=80&w=800&auto=format&fit=crop'
}, {
  id: 3,
  storeId: 'annapolis',
  name: 'Extra Strength Pain Reliever',
  category: 'Pain & Fever',
  price: '$9.99',
  image: 'https://images.unsplash.com/photo-1585435557343-3b092031a831?q=80&w=800&auto=format&fit=crop'
}, {
  id: 4,
  storeId: 'annapolis',
  name: 'Daily Immune Support (60ct)',
  category: 'Vitamins & Supplements',
  price: '$18.75',
  image: 'https://images.unsplash.com/photo-1471864190281-a93a3070b6de?q=80&w=800&auto=format&fit=crop'
}, {
  id: 5,
  storeId: 'dc',
  name: "Children's Allergy Relief",
  category: 'Allergy & Sinus',
  price: '$14.20',
  image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926?q=80&w=800&auto=format&fit=crop'
}, {
  id: 6,
  storeId: 'dc',
  name: 'Moisturizing Skin Therapy',
  category: 'Personal Care',
  price: '$11.45',
  image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?q=80&w=800&auto=format&fit=crop'
}, {
  id: 7,
  storeId: 'dc',
  name: 'Rapid Response First Aid Kit',
  category: 'First Aid',
  price: '$29.99',
  image: 'https://cdn.magicpatterns.com/uploads/xdNDKr9wN59hCtzteEJdbE/pasted-image.jpg'
}, {
  id: 8,
  storeId: 'dc',
  name: 'Digital Instant Thermometer',
  category: 'Health Monitors',
  price: '$34.50',
  image: 'https://cdn.magicpatterns.com/uploads/xdNDKr9wN59hCtzteEJdbE/pasted-image.jpg'
}];
export function ProductGrid({
  storeId,
  searchQuery
}: {
  storeId?: string;
  searchQuery?: string;
}) {
  const {
    addToCart
  } = useCart();
  let filteredProducts = storeId ? PRODUCTS.filter(p => p.storeId === storeId) : PRODUCTS;
  if (searchQuery) {
    const query = searchQuery.toLowerCase();
    filteredProducts = filteredProducts.filter(p => p.name.toLowerCase().includes(query) || p.category.toLowerCase().includes(query));
  }
  const storeName = storeId === 'annapolis' ? 'Annapolis' : storeId === 'dc' ? 'Washington D.C.' : 'All Locations';
  return <section className="py-12 sm:py-24 bg-white border-y border-slate-100" data-id="element-134">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="mb-8 sm:mb-12 flex flex-col md:flex-row md:items-end justify-between gap-4 sm:gap-6" data-id="element-136">
          <div data-id="element-137">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-clinical-blue/5 text-clinical-blue rounded-full text-[10px] font-bold uppercase tracking-widest mb-4" data-id="element-138">
              <span className="w-1.5 h-1.5 bg-clinical-blue rounded-full animate-pulse" data-id="element-139"></span>
              Browsing: {storeName} Store
            </div>
            <h2 className="text-2xl sm:text-3xl font-black text-slate-900 mb-2" data-id="element-140">
              {searchQuery ? `${filteredProducts.length} Result${filteredProducts.length !== 1 ? 's' : ''}` : 'Shop Wellness Essentials'}
            </h2>
            <p className="text-slate-500 text-xs sm:text-sm uppercase tracking-widest font-bold" data-id="element-141">
              Over-the-counter retail
            </p>
          </div>
        </div>

        {filteredProducts.length === 0 ? <div className="py-12 sm:py-20 text-center" data-id="element-142">
            <p className="text-slate-500 text-base sm:text-lg mb-2" data-id="element-143">
              No products found{searchQuery && ` for "${searchQuery}"`}.
            </p>
            <p className="text-slate-400 text-sm" data-id="element-144">
              Try a different search term or browse our full catalog.
            </p>
          </div> : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-10" data-id="element-145">
            {filteredProducts.map(product => <div key={product.id} className="group flex flex-col" data-id="element-146">
                <div className="relative aspect-[4/5] overflow-hidden rounded-lg bg-clean-grey mb-6" data-id="element-147">
                  <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" onError={e => {
              e.currentTarget.onerror = null; // Prevent infinite loop
              e.currentTarget.src = 'https://cdn.magicpatterns.com/uploads/xdNDKr9wN59hCtzteEJdbE/pasted-image.jpg';
            }} data-id="element-148" />
                </div>
                <h3 className="font-bold text-slate-900 mb-1 text-sm leading-tight group-hover:text-clinical-blue transition-colors" data-id="element-149">
                  {product.name}
                </h3>
                <p className="text-lg font-black text-slate-900 mb-6 mt-auto" data-id="element-150">
                  {product.price}
                </p>
                <button onClick={() => addToCart(product)} className="w-full py-3 bg-clinical-blue text-white text-[10px] font-bold uppercase tracking-widest rounded hover:bg-blue-700 transition-all active:scale-95" data-id="element-151">
                  Add to Cart
                </button>
              </div>)}
          </div>}
      </div>
    </section>;
}